module.exports = __webpack_public_path__ + "static/media/ibclogo.b168fd39.png";